module.exports = __webpack_public_path__ + "img/demo2.1fe209db.png";